import {
  Grid, Hidden, List, ListItem, ListItemText, makeStyles, Menu, MenuItem, Typography,
  ListSubheader,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import React, { useContext } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import colors from '../../modules/colors';

function Filters() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentMenu, setCurrentMenu] = React.useState(null);
  const {
    familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
  } = useContext(FiltersContext);

  const classes = makeStyles((theme) => ({
    button: {
      backgroundColor: colors.blue,
      color: colors.white,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      maxWidth: '25%',
      '&:hover': {
        backgroundColor: colors.lightBlue,
        boxShadow: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '30%',
      },
    },
  }))();

  const handleFilterClick = (menu) => (event) => {
    setAnchorEl(event.currentTarget);
    setCurrentMenu(menu);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSettingType = (value) => () => {
    setSettingType(value);
    setCurrentMenu(null);
  };

  const handleChangeFamilyType = (value) => () => {
    setFamilyType(value);
    setCurrentMenu(null);
  };

  const handleChangeChildAge = (value) => () => {
    setChildAge(value);
    setCurrentMenu(null);
  };

  return (
    <>
      <Grid container direction="row">
        {/* <Hidden smDown>
          <Grid item xs={12} md={2}>
            <Typography variant="body1" align="right" style={{ marginRight: 10 }}>Filter By:</Typography>
          </Grid>
        </Hidden> */}
        <Grid item xs={12}>
          <List
            component="nav"
            aria-label="Filters"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              padding: 0,
            }}
            subheader={(
              <Hidden smDown>
                <ListSubheader component="div" id="nested-list-subheader">
                  Filter By:
                </ListSubheader>
              </Hidden>
            )}
          >
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('familyTypeMenu')}
            >
              <ListItemText
                primary="Family Type"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {familyType}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('settingTypeMenu')}
            >
              <ListItemText
                primary="Setting Type"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {settingType}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>
            <ListItem
              className={classes.button}
              button
              dense
              aria-haspopup="true"
              aria-controls="lock-menu"

              onClick={handleFilterClick('childAgeMenu')}
            >
              <ListItemText
                primary="Child Age"
                secondary={(
                  <Typography style={{ color: '#fff' }} variant="caption">
                    {childAge}
                  </Typography>
                )}
              />
              <ExpandMoreIcon />
            </ListItem>

          </List>
        </Grid>

      </Grid>

      <Menu id="settingTypeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'settingTypeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={settingType === 'All'} onClick={handleChangeSettingType('All')}>
          {settingType === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Center-based child care" selected={settingType === 'Center-based child care'} onClick={handleChangeSettingType('Center-based child care')}>
          {settingType === 'Center-based child care' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Center-based child care
        </MenuItem>
        <MenuItem key="Family child care (FCC)" selected={settingType === 'Family child care (FCC)'} onClick={handleChangeSettingType('Family child care (FCC)')}>
          {settingType === 'Family child care (FCC)' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Family child care (FCC)
        </MenuItem>
      </Menu>

      <Menu id="familyTypeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'familyTypeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={familyType === 'All'} onClick={handleChangeFamilyType('All')}>
          {familyType === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Married-couple family" selected={familyType === 'Married-couple family'} onClick={handleChangeFamilyType('Married-couple family')}>
          {familyType === 'Married-couple family' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Married-couple family
        </MenuItem>
        <MenuItem key="Single-parent family" selected={familyType === 'Single-parent family'} onClick={handleChangeFamilyType('Single-parent family')}>
          {familyType === 'Single-parent family' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Single-parent family
        </MenuItem>
      </Menu>

      <Menu id="childAgeMenu" anchorEl={anchorEl} keepMounted open={currentMenu === 'childAgeMenu' && Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem key="All" selected={childAge === 'All'} onClick={handleChangeChildAge('All')}>
          {childAge === 'All' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;All
        </MenuItem>
        <MenuItem key="Infants and Toddlers" selected={childAge === 'Infants and Toddlers'} onClick={handleChangeChildAge('Infants and Toddlers')}>
          {childAge === 'Infants and Toddlers' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Infants and Toddlers
        </MenuItem>
        <MenuItem key="Preschoolers" selected={childAge === 'Preschoolers'} onClick={handleChangeChildAge('Preschoolers')}>
          {childAge === 'Preschoolers' ? <RadioButtonCheckedIcon /> : <RadioButtonUncheckedIcon />}&nbsp;Preschoolers
        </MenuItem>
      </Menu>
    </>
  );
}

export default Filters;
